<template>
  <div>
    <div>
      <b-tabs>
        <b-tab :title="$t('message.Общие')" active>
          <!-- <b-form-group :label="$t('message.Apk_enabled') + ':'" label-for="enabled">
        <b-form-checkbox-group v-model="model.enabled" id="Enabled">
          <b-form-checkbox value="true"></b-form-checkbox>
        </b-form-checkbox-group>
      </b-form-group> -->

          <b-form-group>
            <b-form-checkbox v-model="model.enabled" switch>
              {{ $t("message.Apk_enabled") }}</b-form-checkbox
            >
          </b-form-group>

          <b-form-group
            :label="$t('message.Apk_brand') + ':'"
            label-for="ApkBrands"
          >
            <v-select v-model="model.brand" :options="this.brands" required>
            </v-select>
          </b-form-group>

          <b-form-group
            :label="$t('message.Apk_description') + ':'"
            label-for="description"
          >
            <b-form-input
              id="description"
              type="text"
              v-model="model.description"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group
            :label="$t('message.Apk_build') + ':'"
            label-for="build"
          >
            <b-form-input
              id="build"
              type="text"
              v-model="model.build"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group
            :label="$t('message.Apk_version') + ':'"
            label-for="version"
          >
            <b-form-input
              id="version"
              type="text"
              v-model="model.version"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group :label="$t('message.Apk_name') + ':'" label-for="name">
          <b-form-input
              id="name"
              type="text"
              v-model="model.name"
              :readonly="true"
            ></b-form-input>
          </b-form-group>

          <!-- <b-form-group :label="$t('message.Apk_payload') + ':'" label-for="payload">
        <b-form-input id="payload"  type="text" v-model="model.payload"></b-form-input>
      </b-form-group> -->

          <b-form-group :label="$t('message.Apk_payload')" label-for="Apk file">
            <b-form-file
              v-model="model.payload"
              @change="onFileChange"
              :state="Boolean(model.payload)"
              placeholder="Choose a file..."
            ></b-form-file>
          </b-form-group>

          <b-form-group :label="$t('message.Опции') + ':'" 
            label-for="options">
            <v-jsoneditor
              v-model="model.options"
              :options="options"
              :plus="false"
              @error="onJsonError"
            ></v-jsoneditor>
          </b-form-group>

        </b-tab>
        <b-tab :title="$t('message.Geo_контроль')">
          <b-form-group>
            <b-form-checkbox v-model="model.geo_enabled" switch>{{
              $t("message.Geo_enabled")
            }}</b-form-checkbox>
          </b-form-group>
          <b-form-group :label="$t('message.Geo_коды')" label-for="Countries">
            <v-select
              multiple
              v-model="model.geo_codes"
              :options="this.geo_codes_list"
              label="name"
            ></v-select>
          </b-form-group>
        </b-tab>
        <b-tab :title="$t('message.IPs_контроль')">
          <b-form-group
            :label="$t('message.Apk_ips_only') + ':'"
            label-for="ips_only"
          >
            <b-form-input
              id="ips_only"
              type="text"
              v-model="model.ips_only"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            :label="$t('message.Apk_ips_exclude') + ':'"
            label-for="ips_exclude"
          >
            <b-form-input
              id="ips_exclude"
              type="text"
              v-model="model.ips_exclude"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            :label="$t('message.Apk_ips_list') + ':'"
            label-for="ips_list"
          >
            <b-form-input
              id="ips_list"
              type="text"
              v-model="model.ips_list"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            :label="$t('message.Apk_ips_re_only') + ':'"
            label-for="ips_re_only"
          >
            <b-form-input
              id="ips_re_only"
              type="text"
              v-model="model.ips_re_only"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            :label="$t('message.Apk_ips_re_exclude') + ':'"
            label-for="ips_re_exclude"
          >
            <b-form-input
              id="ips_re_exclude"
              type="text"
              v-model="model.ips_re_exclude"
            ></b-form-input>
          </b-form-group>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import VJsoneditor from "v-jsoneditor";

export default {
  name: "ApkForm",
  props: ["model"],
  components: {
    VJsoneditor
  },  
  data() {
    return {
      geo_codes_list: [],
      brands: [],
      options: {
        mode: "code",
        history: false,
        search: false,
        mainMenuBar: false,
        name: this.$i18n.t("message.Опции"),
        navigationBar: false
      }      
    };
  },
  created: function() {
    let geo_codes_list = this.$noname.get("geo_country_codes", {
      params: { perPage: 10000 }
    });

    let pro_brands = this.$noname.get("apk_brands_select", {
      params: { perPage: 10000 }
    });

    geo_codes_list
      .then(data => {
        this.geo_codes_list = data.data.items;
      })
      .catch(error => {
        Vue.notify({
          group: "notify",
          text:
            this.$i18n.t("message.Geo_не_удалось_получить_список_кодов_стран") +
            ":<br>" +
            error,
          type: "error"
        });
      });

    pro_brands
      .then(data => {
        this.brands = data.data.items;
      })
      .catch(this.$noname.HandleError);
  },
  methods: {
    onJsonError() {
      console.log("error");
    },    
    onFileChange(e) {
      const file = e.target.files[0];
      let reader = new FileReader();

      reader.addEventListener(
        "load",
        function() {
          this.model.payload = reader.result;
          this.model.name = file.name;
        }.bind(this),
        false
      );

      if (file) {
        reader.readAsDataURL(file);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modules/ApkForm.vue